import { PinwheelOutlineIcon } from './PinwheelOutlineIcon';

/**
 * author: Google
 * id 279BF513-8015-4F28-83FD-B69CE7E0EB78
 * name pinwheel-outline
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pinwheel-outline.svg
 * tags
 */
export const ToysOutlineIcon = PinwheelOutlineIcon;
export default ToysOutlineIcon